import { render, staticRenderFns } from "./ClientNavigationItems.vue?vue&type=template&id=99e84a3e"
import script from "./ClientNavigationItems.vue?vue&type=script&lang=js"
export * from "./ClientNavigationItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports